import Constants from 'common/constants'
import { AuthUserInterface, JWTTokenInterface } from './interfaces'
import config from 'common/config'
import Http from 'common/http'
import { Permissoes } from 'pages/admin/access/interfaces'

const LOCAL_STORAGE_KEY = 'auth'

function parseJwt(token: string): JWTTokenInterface {
  try {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch {
    return {
      auth_time: 0,
      exp: 0,
      iat: 0,
      email: '',
      email_verified: false,
      iss: '',
      aud: '',
      jti: '',
      origin_jti: '',
      sub: '',
      token_use: '',
      realm_access: {
        roles: []
      },
      resource_access: {
        auth: {
          roles: []
        }
      },
      groupRoles: []
    }
  }
}

const isTokenValid = (jwt: JWTTokenInterface) => {
  const expirationTimeInMiliseconds = jwt.exp * 1000
  const now = Date.now()
  return now < expirationTimeInMiliseconds
}

const getGroupRoles = (jwt?: JWTTokenInterface) => {
  if (!jwt) {
    return []
  }
  if (!jwt?.groupRoles || !Array.isArray(jwt.groupRoles)) {
    return []
  }
  return jwt.groupRoles
}

const isEmployee = (jwt?: JWTTokenInterface) => {
  return getGroupRoles(jwt).includes(Constants.GROUP_ROLE.EMPLOYEE)
}
const isAdmin = (jwt?: JWTTokenInterface) => {
  return getGroupRoles(jwt).includes(Constants.GROUP_ROLE.ADMIN)
}
const isCustomer = (jwt?: JWTTokenInterface) => {
  return getGroupRoles(jwt).includes(Constants.GROUP_ROLE.CUSTOMER)
}

const isPartnerBroker = (jwt?: JWTTokenInterface) => {
  return getGroupRoles(jwt).includes(Constants.GROUP_ROLE.PARTNER_BROKER)
}

const requestInitForPublicBackendRoute = (): RequestInit => {
  try {
    const raw = localStorage.getItem(Constants.TOKEN_LOCAL_STORAGE) || ''
    if (raw === '') {
      return { credentials: 'omit' }
    }
    const jwt = parseJwt(raw)
    if (!isTokenValid(jwt)) {
      return { credentials: 'omit' }
    }
    return {}
  } catch {
    return { credentials: 'omit' }
  }
}

const AuthModule = {
  parseJwt,
  isAdmin,
  isCustomer,
  isEmployee,
  isTokenValid,
  isPartnerBroker,
  requestInitForPublicBackendRoute,
  // TODO: DEIXAR SINCRONO QUANDO COLOCAR AS PERMISSIONS NO AWS
  getAuthData: async (): Promise<AuthUserInterface | null> => {
    try {
      const auth = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (auth) {
        const authData = JSON.parse(auth)
        const jwt = parseJwt(authData?.accessToken)
        const permissions = jwt?.resource_access?.auth?.roles ?? []
        return {
          jwt,
          authData,
          permissions
        }
      }

      return null
    } catch {
      return null
    }
  }
}

export default AuthModule
